import React from "react";
import { Star, StarOutline } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import { useStarred } from "fond/projects/ItemMenu/hooks/useStarred";
import { Folder, MultiProject, Project, Report } from "fond/types";

interface IProps {
  entity: Project | Report | Folder | MultiProject;
}

const StarButton: React.FC<IProps> = ({ entity }) => {
  const { starred, addToStarred, removeFromStarred } = useStarred();

  const isEntityStarred = starred.includes(entity.ID);

  return (
    <Tooltip title={isEntityStarred ? "Remove from Starred" : "Add to Starred"}>
      <IconButton
        data-testid="starred-button"
        size="small"
        onClick={() => {
          if (isEntityStarred) removeFromStarred(entity, "topbar");
          else addToStarred(entity, "topbar");
        }}
      >
        {isEntityStarred ? <Star /> : <StarOutline />}
      </IconButton>
    </Tooltip>
  );
};

export default StarButton;
